<h3 class="h3 m-b"
*iCms="'title' of component; skipEmpty: true"></h3>

@for (tab of component.tabs; track $index; let i = $index; let isLast = $last; let isFirst = $first) {
  <div class="p-t-2 p-b-2 p-r-2 b-t p-t-3-s p-b-3-s"
    [ngClass]="tab.border_color ? 'b-'+tab.border_color : 'b-col-5'"
    [class.b-b]="isLast"
    >
    <!-- header -->
    <div class="w-12 cursor-pointer flex flex-middle flex-justify-between"
      [zippyToggle]="['content_tab', uid, i]">
      <h6 class="cursor-pointer"
        [ngClass]="tab.title_style"
        *iCms="'title' of tab; content: 'html'">
      </h6>
      <i class="transition icon-plus"
        [ngClass]="tab.arrow_style"
        zippyClass="icon-minus !icon-plus"
        [zippyName]="['content_tab', uid, i]">
      </i>
    </div>
    <!-- content -->
    <div [zippyAnimationDuration]="350"
      [zippyHideUp]="['content_tab', uid, i]">
      <icms-outlet [components]=" tab.components"
      [name]=" 'Tab content'  "></icms-outlet>
    </div>
  </div>
}